module.exports = __webpack_public_path__ + "static/media/Introducing the Command Line in AutoCAD mobile.9aeded3c.png";